import ModalPortal from "./ModalPortal";
import DialogLayout from "./subComponent/index";
import "./styles/index.styl";
const Dialog = {
  ModalPortal,
  DialogLayout
};

export default Dialog;
